import React, { useState, useCallback, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { GridLayout } from "../../../../../common/GridLayout";
import {AllowedPageSizes} from '../../../../../const/constants';
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar,
    Item,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    ColumnHeaderFilter,
} from "devextreme-react/data-grid";
const LaborTrackingSubTab = (props) => {
    const dataGrid = useRef(null);
    var accessToken = props.oidc.user.access_token;
    
    //  const gridKey = "A578449C-E2CC-42CA-8B0B-B0F8570C7A3C";
    const [currentLayout, setCurrentLayout] = useState("Default");
    // const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    // const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    return (
        <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                ref={dataGrid}
                dataSource={props.data}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                hoverStateEnabled={true}
                className="SearchOrderSalesResultOpenState"
                style={{ height: '100%', minHeight: 0 }}
                searchExpr="status"
                remoteOperations={true}
                searchEnabled={true}
                columnAutoWidth={true}
                scrolling={{ mode: "standard" }}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <Export enabled={true} allowExportSelectedData={true} />
                <Selection mode="none" />
                <Sorting visible={true} mode="multiple" />
                <Paging defaultPageSize={25} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={AllowedPageSizes}
                    showNavigationButtons={true}
                />
                <FilterRow visible={false} />
                <FilterPanel visible={false} />
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <StateStoring
                    enabled={true}
                    type="custom"
                // customLoad={loadState}
                // storageKey={gridKey}
                // customSave={saveState}
                />
                <Scrolling rowRenderingMode="virtual" />
             
                <Scrolling mode="virtual" />
                <Column dataField="identityId" caption="Worker Id" />
                <Column dataField="name" caption="Worker Name" />
                <Column
                    dataField="startDate"
                    caption="Start Date"
                    dataType="date"
                    format="MM/dd/yyyy"
                />
                <Column
                    dataField="endDate"
                    caption="End Date"
                    dataType="date"
                    format="MM/dd/yyyy"
                />
                <Column dataField="workUnitUOM" caption="Work UOM" dataType="string"/>
                <Column
                    dataField="workUnitQuantity"
                    caption="Work Quantity"
                    dataType="number"
                />
                <Column
                    dataField="elapsedHours"
                    caption="Elapsed Hours"
                    dataType="number"
                />
                <Column
                    dataField="elapsedMinutes"
                    caption="Elapsed Minutes"
                    dataType="number"
                />
                <Column
                    dataField="taskCount"
                    caption="Task Count"
                    dataType="number"
                />
                <Column
                    dataField="taskTotalMinutes"
                    caption="Task Total Minutes"
                    dataType="number"
                />
                <Column visible={false} dataField="userDefinedCode1" caption="Code1" dataType="string" />
                <Column visible={false} dataField="userDefinedCode2" caption="Code2" dataType="string" />
                <Column visible={false} dataField="userDefinedCode3" caption="Code3" dataType="string" />
                <Column visible={false} dataField="userDefinedQuantity1" caption="Quantity1 " dataType="number" />
                <Column visible={false} dataField="userDefinedQuantity2" caption="Quantity2 " dataType="number" />
                <Column visible={false} dataField="userDefinedQuantity3" caption="Quantity3 " dataType="number" />
                <Column visible={false} dataField="userDefinedReference1" caption="Reference1" dataType="string" />
                <Column visible={false} dataField="userDefinedReference2" caption="Reference2" dataType="string" />
                <Column visible={false} dataField="userDefinedReference3" caption="Reference3" dataType="string" />
                <Column visible={false} dataField="activity" caption="Activity" dataType="string" />
                <Column visible={false} dataField="comapnyID" caption="Comapny ID" dataType="string" />
                <Column visible={false} dataField="createdBy" caption="Created By" dataType="string" />
                <Column visible={false} dataField="creationDate" caption="Creation Date" dataType="date" format="MM/dd/yyyy" />
                <Column visible={false} dataField="lastUpdated" caption="Last Updated" dataType="date" format="MM/dd/yyyy" />
                <Column visible={false} dataField="lastUpdatedBy" caption="Last Update dBy" dataType="string" />
                <Column visible={false} dataField="module" caption="Module" dataType="string" />
                <Column visible={false} dataField="recordNumber" caption="Record Number" dataType="string" />
                <Column visible={false} dataField="recordType" caption="Record Type" dataType="string" />
                <Column visible={false} dataField="sourceTableName" caption="Source Table Name" dataType="string" />
                <Toolbar>
                    {/* <Item location="after">
                        <GridLayoutManager   dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item> */}
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
        </div>
    )
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(LaborTrackingSubTab);